import React, { Component } from "react";
import "../../Pages/Schedular.css";
import { post, del, get } from "../../custom_libraries/serverRequests";
import urls from "../../custom_libraries/urls";
import globalVariables from "../../custom_libraries/globalVariables";
import Alert from "@mui/material/Alert";
import CheckIcon from "@mui/icons-material/Check";
import Tooltip from "@mui/material/Tooltip";
// import withNavigate from "../../Global_files/WithNavigate";
import BACK from '../../assets/icons8-back-arrow.gif'; 
import VideocamIcon from '@mui/icons-material/Videocam'; // CCTV-like icon
import { Switch, FormControlLabel, Box } from "@mui/material";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

//-------------dark theme-------------------------------------
import { createTheme, ThemeProvider } from "@mui/material/styles"; //MUI dark theme using ThemeProvider
import CssBaseline from "@mui/material/CssBaseline";

const darkTheme = createTheme({
  palette: {
    mode: "dark",
    background: {
      default: "#191e29",
      paper: "#212632",
    },
    text: {
      primary: "#ffffff",
      secondary: "#fafafa",
    },
  },
});
//------------------------------------------


const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
// const timeSlots = Array.from({ length: 25 }, (_, i) =>
//   `${i === 0 ? 12 : i > 12 ? i - 12 : i}:00 ${i < 12 ? "AM" : "PM"}`
// );

// 24-hour format time slots (00:00 → 23:00)
const timeSlots = Array.from({ length: 24 }, (_, i) =>
  `${i.toString().padStart(2, "0")}:00`
);



class Scheduler extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedBlocks: [],
      isDragging: false,
      success: false,
      error: false,
      warning: false,
      error_fetching:false,
      warning_fetching:false,
      success_clear: false,
      isEditing: false,
      frequency: "custom",
      originalSelectedBlocks: [], 
      deviceId:null,
        // Video Analytics Scheduler
      vaSelectedBlocks: [],
      vaOriginalSelectedBlocks: [],
      vaIsEditing: false,
      // Mode toggle
      isVideoAnalyticsMode: true, // [NEW]
      is_rtsp_device: false,
      isAllCamerasMuted: false,
    };
  }

  componentDidMount() {
    const IsRtspDevice = localStorage.getItem(globalVariables.IS_RTSP_DEVICE);
    this.setState ({
        is_rtsp_device : IsRtspDevice === 'True' ? true : false,
        deviceId: localStorage.getItem(globalVariables.DEVICE_ID)
    })
    // this.fetchScheduleData();  //removing this to load VA schedule by default to minimise API calls. on page mount. loading it conditionally based on toggle mode.
    this.fetchVAScheduleData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
        this.state.warning !== prevState.warning ||
        this.state.error !== prevState.error ||
        this.state.error_fetching !== prevState.error_fetching ||
        this.state.warning_fetching !== prevState.warning_fetching ||
        this.state.success_clear !== prevState.success_clear ||
        this.state.success !== prevState.success
    ) {
        if (
            this.state.warning ||
            this.state.error ||
            this.state.warning_fetching ||
            this.state.error_fetching ||
            this.state.success_clear ||
            this.state.success
        ) {
            setTimeout(() => {
                this.setState({
                    warning: false,
                    error: false,
                    warning_fetching: false,
                    error_fetching: false,
                    success_clear: false,
                    success: false,
                });
            }, 2500); // 1 second
        }
    }
  }

  toggleSchedulerMode = () => {
    // this.setState((prev) => ({
    //   isVideoAnalyticsMode: !prev.isVideoAnalyticsMode,
    // }));
    this.setState(
    prev => ({ isVideoAnalyticsMode: !prev.isVideoAnalyticsMode }),
    () => {
      if (this.state.isVideoAnalyticsMode) {
        this.fetchVAScheduleData();   // Load VA schedule
      } else {
        if((this.props.camera_health_mute_count === this.props.camera_count)) {
          // this.openSnackbar("Please Add the schedule first then only you can unmute the camera", "warning");
          this.setState({isAllCamerasMuted:true});
          return;
        }
        this.fetchScheduleData();     // Load Camera Health schedule
      }
    }
  );
  };

  // --- Toggle Edit Mode ---
  toggleEditMode = () => {
    if (this.state.isVideoAnalyticsMode) {
      this.setState((prev) => ({
        vaIsEditing: !prev.vaIsEditing,
        vaOriginalSelectedBlocks: !prev.vaIsEditing ? [...prev.vaSelectedBlocks] : prev.vaOriginalSelectedBlocks,
      }));
    } else {
      this.setState((prev) => ({
        isEditing: !prev.isEditing,
        originalSelectedBlocks: !prev.isEditing ? [...prev.selectedBlocks] : prev.originalSelectedBlocks,
      }));
    }
  };

  // toggleEditMode = () => {
  //   this.setState((prevState) => {
  //     const newState = { isEditing: !prevState.isEditing };
  //     if (!prevState.isEditing) {
  //       // Store the original blocks when entering edit mode
  //       newState.originalSelectedBlocks = [...prevState.selectedBlocks];
  //     }
  //     return newState;
  //   });
  // };

  // cancelEdit = () => {
  //   // Revert to the original state before any changes
  //   this.setState((prevState) => ({
  //     selectedBlocks: [...prevState.originalSelectedBlocks],
  //     isEditing: false,
  //   }));
  // };

  cancelEdit = () => {
    if (this.state.isVideoAnalyticsMode) {
      this.setState((prev) => ({
        vaIsEditing: false,
        vaSelectedBlocks: [...prev.vaOriginalSelectedBlocks],
      }));
    } else {
      this.setState((prev) => ({
        isEditing: false,
        selectedBlocks: [...prev.originalSelectedBlocks],
      }));
    }
  };

  // handleCellClick = (day, time) => {
  //   const block = { day, time };

  //   this.setState((prevState) => {
  //     const isSelected = prevState.selectedBlocks.some((b) => b.day === day && b.time === time);

  //     return {
  //       selectedBlocks: isSelected
  //         ? prevState.selectedBlocks.filter((b) => !(b.day === day && b.time === time)) // Remove if already selected
  //         : [...prevState.selectedBlocks, block], // Add new block
  //     };
  //   });
  // };

   handleCellClick = (day, time) => {
    const block = { day, time };

    if (this.state.isVideoAnalyticsMode) {
      this.setState((prev) => {
        const exists = prev.vaSelectedBlocks.some((b) => b.day === day && b.time === time);
        const updated = exists
          ? prev.vaSelectedBlocks.filter((b) => !(b.day === day && b.time === time))
          : [...prev.vaSelectedBlocks, block];
        return { vaSelectedBlocks: updated };
      });
    } else {
      this.setState((prev) => {
        const exists = prev.selectedBlocks.some((b) => b.day === day && b.time === time);
        const updated = exists
          ? prev.selectedBlocks.filter((b) => !(b.day === day && b.time === time))
          : [...prev.selectedBlocks, block];
        return { selectedBlocks: updated };
      });
    }
  };


  handleMouseDown = (day, time) => {
    this.setState({ isDragging: true });
    this.handleCellClick(day, time);
  };

  handleMouseEnter = (day, time) => {
    if (this.state.isDragging) {
      this.handleCellClick(day, time);
    }
  };

  handleMouseUp = () => {
    this.setState({ isDragging: false });
  };

  clearAllSchedules = async () => {
    const deviceId = localStorage.getItem(globalVariables.DEVICE_ID);
    
    if (!deviceId) {
      this.setState({ warning: true });
      console.error("Camera ID is missing.");
      return;
    }

    try {
      const response = await post(urls.CLEAR_SCHEDULE_DATA(deviceId));
      console.log("All schedules cleared response.------", response);
      const expectedMessage = `All schedules for device ${deviceId} have been cleared.`;

      if (response === true) {
        this.setState({ selectedBlocks: [], success_clear: true });
        console.log("All schedules cleared successfully.");
        setTimeout(() => {
        this.setState({isEditing:false, success_clear:false});
        this.fetchScheduleData()
      //     window.location.reload();
      }, 4000);
        
      } else {
        console.error("Failed to clear schedules:", response);
        this.setState({ error: true });
      }
    } catch (error) {
      console.error("Error clearing schedules:", error);
      this.setState({ error: true });
    }
  };


// Function to convert 12-hour time to 24-hour format
convertTo24HourFormat = (timeStr) => {
  const [time, modifier] = timeStr.split(" "); // Split time and AM/PM
  let [hours, minutes] = time.split(":").map(Number);

  if (modifier === "PM" && hours !== 12) {
      hours += 12;
  } else if (modifier === "AM" && hours === 12) {
      hours = 0;
  }

  return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;
};

// convertTo12HourFormat = (timeStr) => {
//   let [hours, minutes] = timeStr.split(":").map(Number);
//   const period = hours >= 12 ? "PM" : "AM";
//   hours = hours % 12 || 12;
//   return `${hours}:${minutes.toString().padStart(2, "0")} ${period}`;
// };

  
          
  sendDeviceSchedule = async () => {
    const { selectedBlocks, frequency } = this.state;
    const deviceId = localStorage.getItem(globalVariables.DEVICE_ID);
  
    if (!deviceId) {
      this.setState({ warning: true });
      console.error("DeviceID is missing.");
      setTimeout(() => {
        this.setState({warning:false});
      }, 4500);
      return;
    }
  
    if (selectedBlocks.length === 0) {
      this.setState({ warning: true });
      console.error("No time blocks selected.");
      setTimeout(() => {
        this.setState({warning:false});
      }, 4500);
      return;
    }
  
    const payload = {
      device: deviceId,
      frequency,
      schedule: selectedBlocks.map((block) => ({
        device: deviceId,
        frequency,
        day: block.day,
        // time: block.time,
        time: this.convertTo24HourFormat(block.time), // Convert time to HH:mm
        id: block.id || null, // Include ID for updating existing schedules
      })),
    };
    const url = urls.UPDATE_SCHEDULE_DATA;
    console.log("URL for PUT request:", url);
    console.log("Payload for PUT request:", payload);
    try {
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
      // console.log("--------auth tocken---------", access_tocken);
      console.log("Payload:", payload);
      const response = await fetch(urls.UPDATE_SCHEDULE_DATA, {
        method: "POST", // Use PUT instead of POST
        headers: {
          "Content-Type": "application/json",
          'Authorization': `Bearer ${access_tocken}`
        },
        body: JSON.stringify(payload),
      });
  
      if (response.ok) {
        console.log("Schedules updated successfully.");
        this.setState({ success: true });
      } else {
        const errorData = await response.json();
        console.error("Error updating schedules:", errorData);
        this.setState({ error: true });
      }
      setTimeout(() => {
        // window.location.reload();
        this.setState({isEditing:false, success: false});
        this.fetchScheduleData()
    }, 2500);
    } catch (error) {
      console.error("Network or API error:", error);
      this.setState({ error: true });
    }
  };
  

  fetchScheduleData = async () => {
    try {
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN);
      console.log("--------auth tocken---------", access_tocken);
      let headers = {
          'content-type': 'application/json',
          'Authorization': `Bearer ${access_tocken}`
      }
      const deviceID = localStorage.getItem(globalVariables.DEVICE_ID);
      if (!deviceID) {
        console.error("Device ID is missing.");
        // this.setState({ error_fetching: true });
        return;
      }
  
      // const response = await fetch(urls.GET_SCHEDULE_DATA(deviceID), headers);
      const response = await fetch(urls.GET_SCHEDULE_DATA(deviceID), {
                  headers: headers,
              });
      console.log("Response: fetchScheduleData", response);
      if (response.ok) {
        const data = await response.json();
        console.log("Response: fetchScheduleData", data);
  
        if (Array.isArray(data?.data) && data.data.length > 0) {
          const selectedBlocks = data.data.map((item) => ({
            day: item.day,
            // time: this.convertTo12HourFormat(item.time), // Convert time for matching
            time: item.time, // Use time as-is (24-hour format)
            id: item.schedule_id, // Include schedule ID for potential deletion
          }));
  
          this.setState({ selectedBlocks });
          console.log("Selected Blocks: fetchScheduleData", this.state.selectedBlocks);
        } else {
          console.warn("No schedule data available. Please add schedule.");
          this.setState({ warning_fetching: true });
        }
      } else {
        console.error("Failed to fetch schedule data:", response.status);
        this.setState({ error_fetching: true });
      }
    } catch (error) {
      console.error("Error fetching schedule data:", error);
      this.setState({ error_fetching: true });
    }
  };

  //Video Analytic Schedular
  sendVADeviceSchedule = async () => {
    const { vaSelectedBlocks } = this.state;
    const deviceId = localStorage.getItem(globalVariables.DEVICE_ID);

    if (!deviceId) {
      this.setState({ warning: true });
      console.error("DeviceID is missing.");
      setTimeout(() => this.setState({ warning: false }), 4500);
      return;
    }

    if (!vaSelectedBlocks || vaSelectedBlocks.length === 0) {
      this.setState({ warning: true });
      console.error("No time blocks selected.");
      setTimeout(() => this.setState({ warning: false }), 4500);
      return;
    }

    const daysOrder = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    // Group by day
    const groupedByDay = {};
    vaSelectedBlocks.forEach((block) => {
      const day = block.day;
      const hour = parseInt(this.convertTo24HourFormat(block.time).split(":")[0], 10);
      if (!groupedByDay[day]) groupedByDay[day] = [];
      groupedByDay[day].push(hour);
    });

    const schedules = [];

    Object.entries(groupedByDay).forEach(([day, hours]) => {
      const sortedHours = [...new Set(hours)].sort((a, b) => a - b); // remove duplicates and sort
      let start = sortedHours[0];

      for (let i = 1; i <= sortedHours.length; i++) {
    // Check if it's the end of a continuous sequence
    if (sortedHours[i] !== sortedHours[i - 1] + 1) {
      const start_time = `${start.toString().padStart(2, "0")}:00`;
      
  let endHour = sortedHours[i - 1] + 1;
  if (endHour >= 24) {
    endHour = 23;
    const end_time = "23:59"; // ← use 23:59 instead of 24:00
    schedules.push({
      start_time: `${start.toString().padStart(2, "0")}:00`,
      end_time,
      days: day
    });
  } else {
    const end_time = `${endHour.toString().padStart(2, "0")}:00`;
    schedules.push({
      start_time: `${start.toString().padStart(2, "0")}:00`,
      end_time,
      days: day
    });
  }

      // Start a new sequence
      start = sortedHours[i];
    }
  }
    });

    const payload = {
      device: parseInt(deviceId, 10),
      schedules,
    };

    console.log("Merged Payload for VA Alert Schedule POST:", payload);

    try {
      const access_token = localStorage.getItem(globalVariables.AUTH_TOKEN);
      const response = await fetch(urls.UPDATE_ALERT_SCHEDULE, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        const result = await response.json();
        console.log("VA schedule saved successfully:", result);
        this.setState({ success: true });
      } else {
        const errData = await response.json();
        console.error("Error saving VA schedule:", errData);
        this.setState({ error: true });
      }

    setTimeout(() => {
    this.setState((prevState) => ({
      success: false,
      isEditing: prevState.isVideoAnalyticsMode ? prevState.isEditing : false,
      vaIsEditing: prevState.isVideoAnalyticsMode ? false : prevState.vaIsEditing,
    }), () => {
      if (this.state.isVideoAnalyticsMode) {
        this.fetchVAScheduleData();
      } else {
        this.fetchScheduleData();
      }
    });
  }, 2500);
    } catch (error) {
      console.error("Network or API error:", error);
      this.setState({ error: true, success: false });
    }
  };


  clearVideoAnalyticsSchedule = async () => {
    const deviceId = localStorage.getItem(globalVariables.DEVICE_ID);
    if (!deviceId) {
      this.setState({ warning: true });
      return;
    }

    try {
      const token = localStorage.getItem(globalVariables.AUTH_TOKEN);
      const res = await fetch(urls.CLEAR_ALERT_SCHEDULE(deviceId), {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      });

      const result = await res.json();
      console.log("Clear VA schedule response:", result);

      if (res.ok && result?.success !== false) {
        this.setState({ vaSelectedBlocks: [], vaIsEditing: false, success_clear: true });
        setTimeout(() => {
          this.setState({ success_clear: false });
          this.fetchVAScheduleData(); // Refresh
        }, 2500);
      } else {
        console.error("Failed to clear VA schedule");
        this.setState({ error: true });
      }

    } catch (err) {
      console.error("Error clearing VA schedule:", err);
      this.setState({ error: true });
    }
  };

  fetchVAScheduleData = async () => {
    const deviceId = localStorage.getItem(globalVariables.DEVICE_ID);
    const token = localStorage.getItem(globalVariables.AUTH_TOKEN);

    if (!deviceId) {
      console.error("Device ID is missing.");
      return;
    }

    try {
      const response = await fetch(urls.GET_ALERT_SCHEDULES(deviceId), {
        method: "GET",
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      });

      console.log("Response: fetchVAScheduleData", response);

      if (!response.ok) {
        console.error("Failed to fetch VA schedule:", response.status);
        this.setState({ error_fetching: true });
        return;
      }

      const result = await response.json();
      const { data } = result;

      const vaSelectedBlocks = [];

      data.forEach(schedule => {
        const { start_time, end_time, days, alert_schedule_id } = schedule;
        const dayList = days.split(",").map(day => day.trim()).filter(Boolean);

        const startHour = parseInt(start_time.split(":")[0], 10);
        let endHour = parseInt(end_time.split(":")[0], 10);
        let endMinute = parseInt(end_time.split(":")[1], 10);
        if (endMinute > 0) {
          endHour += 1; // Include this hour if end minute is not 00
        }

        for (let hour = startHour; hour < endHour; hour++) {
          if (hour >= 24) break; 
                // const timeLabel = this.convertTo12HourFormat(`${hour.toString().padStart(2, '0')}:00`);
                const timeLabel = `${hour.toString().padStart(2, '0')}:00`;
                dayList.forEach(day => {
                  const fullDay = this.getFullDayName(day);
                  vaSelectedBlocks.push({ day: fullDay, time: timeLabel, id: alert_schedule_id });
                });
        }
      });

      this.setState({ vaSelectedBlocks }, () => {
        console.log("Selected Blocks for UI:", this.state.vaSelectedBlocks);
      });

      // flag to check full day (24 hr) schedule availability in any day of the week -------

      const dayCoverage = {}; // e.g. { Monday: 24, Tuesday: 12, ... }
      vaSelectedBlocks.forEach(block => {
        if (!dayCoverage[block.day]) dayCoverage[block.day] = new Set();
        dayCoverage[block.day].add(block.time);
      });

      // ✅ Get today's day name (e.g. "Monday", "Tuesday", etc.)
      const today = new Date();
      const todayName = today.toLocaleDateString("en-US", { weekday: "long" });

      // ✅ Check if today has full 24-hour coverage
      const hasFullDay = dayCoverage[todayName] && dayCoverage[todayName].size === 24;  //checking only for today's full day schedule availability.
      // const hasFullDay = Object.values(dayCoverage).some(set => set.size === 24);  //previously checking if any day of the week has 24hrs schedule

      localStorage.setItem("HAS_FULL_DAY_SCHEDULE", hasFullDay ? "true" : "false");
      //--------------------------------------------------------------------------------------

    } catch (error) {
      console.error("Error fetching VA schedule data:", error);
      this.setState({ error_fetching: true });
    }
  };

  // Utility to convert "mon" → "Monday"
  getFullDayName = (short) => {
    const map = {
      mon: "Monday",
      tue: "Tuesday",
      wed: "Wednesday",
      thu: "Thursday",
      fri: "Friday",
      sat: "Saturday",
      sun: "Sunday",
    };
    return map[short.toLowerCase()] || short;
  };

  render() {
    const { selectedBlocks, success, error, warning, isEditing, warning_fetching, error_fetching, success_clear, isVideoAnalyticsMode, vaSelectedBlocks, vaIsEditing, is_rtsp_device} = this.state;
    const activeBlocks = isVideoAnalyticsMode ? vaSelectedBlocks : selectedBlocks;
    const isCurrentlyEditing = isVideoAnalyticsMode ? vaIsEditing : isEditing;
    const cameraLength = this.props.cameraLength;
    // console.log("!isCurrentlyEditing", !isCurrentlyEditing, isEditing, isVideoAnalyticsMode);
    


    return (
      <ThemeProvider theme={darkTheme}>
        <CssBaseline />
        <style>{`
          @media (max-width: 768px) {
            .scheduler-container-schedule {
              width: 100%;
              min-width: 0;
              padding: 8px;
              box-sizing: border-box;
              overflow: hidden;
            }

            .scheduler-container-schedule .MuiAlert-root {
              width: 100%;
              box-sizing: border-box;
              overflow-wrap: anywhere;
            }

            .scheduler-toggle {
              align-items: flex-start !important;
              flex-wrap: wrap;
              gap: 8px !important;
              margin-bottom: 12px !important;
            }

            .scheduler-toggle .MuiFormControlLabel-root {
              min-width: 0;
              margin-right: 0;
              flex: 1 1 190px;
              align-items: flex-start;
            }

            .scheduler-toggle .MuiFormControlLabel-label {
              min-width: 0;
              padding-top: 8px;
            }

            .scheduler-toggle .MuiBox-root {
              align-items: flex-start;
            }

            .scheduler-toggle .MuiBox-root > span {
              white-space: normal;
              overflow-wrap: anywhere;
            }

            .scheduler-grid-scroll {
              width: 100%;
              max-width: 100%;
              overflow-x: auto;
              overflow-y: hidden;
              -webkit-overflow-scrolling: touch;
              scrollbar-width: thin;
              border: 1px solid #5b6e87;
              box-sizing: border-box;
            }

            .scheduler-grid-scroll .grid-header-schedule,
            .scheduler-grid-scroll .grid-body-schedule,
            .scheduler-grid-scroll .row-schedule {
              width: 1105px;
              min-width: 1105px;
            }

            .scheduler-grid-scroll .grid-header-schedule,
            .scheduler-grid-scroll .row-schedule {
              grid-template-columns: 95px repeat(24, 42px);
            }

            .scheduler-grid-scroll .empty-cell-schedule,
            .scheduler-grid-scroll .day-cell-schedule {
              position: sticky;
              left: 0;
              z-index: 2;
              box-sizing: border-box;
            }

            .scheduler-grid-scroll .empty-cell-schedule {
              background-color: #2f353f;
              border: 1px solid #ddd;
              z-index: 3;
            }

            .scheduler-grid-scroll .header-cell-schedule {
              padding: 6px 2px;
              box-sizing: border-box;
            }

            .scheduler-grid-scroll .cell-schedule {
              min-height: 42px;
              height: 42px;
              touch-action: manipulation;
              box-sizing: border-box;
            }

            .buttons-schedule {
              width: 100%;
              flex-wrap: wrap;
              gap: 8px;
            }

            .buttons-schedule button {
              flex: 1 1 110px;
              min-height: 42px;
              margin-left: 0;
            }
          }
        `}</style>
        <div className="scheduler-container-schedule">
          {warning && <Alert severity="warning">Please select the required fields.</Alert>}
          {error && <Alert severity="error">Server Error! Could not process the request.</Alert>}
          {success && (
            <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
              Schedule information saved successfully.
            </Alert>
          )}
          {this.state.isAllCamerasMuted && (
            <Alert severity="warning" 
              // onClose={() => this.setState({isAllCamerasMuted:false})}
            >
              Please unmute at least one camera to add a schedule.
            </Alert>
          )}
        {error_fetching && <Alert severity="error">Server Error! Could not get the scheduled time data.</Alert>}
        {warning_fetching && <Alert severity="warning">No scheduled time data available. Please add schedule.</Alert>}
        {success_clear && (
            <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
              Scheduled time data deleted successfully.
            </Alert>
          )}


            {/* Toggle Scheduler Mode */}
        <div
    className="scheduler-toggle"
    style={{ display: "flex", alignItems: "center", gap: "1rem", marginBottom: "1rem" }}
  >
    <div style={{ position: "center" }}>
      <VideocamIcon
        fontSize="large"
        style={{
          color: isVideoAnalyticsMode ? "#839acd" : "#9e9e9e",
          transform: isVideoAnalyticsMode ? "scale(1.1)" : "scale(1)",
          transition: "transform 0.3s ease, color 0.3s ease",
        }}
      />
      {isVideoAnalyticsMode && (
        <div
          style={{
            position: "absolute",
            top: 2,
            right: 2,
            width: 6,
            height: 6,
            borderRadius: "100%",
            backgroundColor: "red",
            animation: "blink 1s infinite",
          }}
        ></div>
      )}
    </div>

    <FormControlLabel
      control={
        <Switch
          checked={isVideoAnalyticsMode}
          onChange={this.toggleSchedulerMode}
          color="primary"
        />
      }
      label={
      <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "6px"
      }}
    >
      <span
        style={{
          fontWeight: 600,
          fontSize: "1rem",
          color: isVideoAnalyticsMode ? "#839acd" : "#83a7cd", // Deep indigo vs. deep green
          transition: "color 0.3s ease"
        }}
      >
        {isVideoAnalyticsMode
          ? "Video Analytics Scheduler"
          : "Camera Health Scheduler"}
      </span>
      {!isVideoAnalyticsMode && (
        <Tooltip 
          title="The report will be sent to the user's email within 10 to 15 minutes of the scheduled time." 
          placement="right"
          componentsProps={{
            tooltip: {
              sx: {
                backgroundColor: '#283348',
                color: '#fff',
                fontSize: '12px',
                border: '1px solid #99acb8',
              },
            },
            arrow: {
              sx: {
                color: '#283348',
              },
            },
          }}
        >
          <InfoOutlinedIcon
            style={{
              fontSize: "18px",
              color: "#83a7cd",
              cursor: "pointer"
            }}
          />
        </Tooltip>
      )}
      </Box>
    }
    />
  </div>
          {/* <div style={{display:'flex', flexDirection:'row'}}>
          
          </div> */}
          <div className="scheduler-grid-scroll">
            <div className="grid-header-schedule">
              <div className="am-row">
              {is_rtsp_device ? (
                <>AM <span style={{fontSize:'12px', color:'#dbdbdbba'}}>({this.props.siteTimezone})</span></>
                ) : (
                <>AM <span style={{fontSize:'12px', color:'#dbdbdbba'}}>({this.props.timezone})</span></>
                )}
            </div>
            <div className="pm-row">
                {/* PM <span style={{fontSize:'12px', color:'gray'}}>({this.props.timezone})</span> */}
                {is_rtsp_device ? (
                <>PM <span style={{fontSize:'12px', color:'#dbdbdbba'}}>({this.props.siteTimezone})</span></>
                ) : (
                <>PM <span style={{fontSize:'12px', color:'#dbdbdbba'}}>({this.props.timezone})</span></>
                )}
            </div>
            <div className="empty-cell-schedule"></div>
              {timeSlots.map((time, index) => (
                <div key={`${time}-${index}`} className="header-cell-schedule">
            {/* {time.split(" ")[0]}  Only show the hour:minute */}
                  {time}
                </div>
            ))}
          </div>

          <div className="grid-body-schedule" onMouseLeave={() => this.setState({ isDragging: false })}>
            {days.map((day) => (
              <div key={day} className="row-schedule">
                <div className="day-cell-schedule">{day}</div>
                {timeSlots.map((time, index) => (

          <div
                className={`cell-schedule ${
                activeBlocks.some((b) => b.day === day && b.time === time)
                ? "selected-schedule"
                : ""
              } ${isCurrentlyEditing ? "editable" : "readonly"}`} //the space behind the ${isCurrentlyEditing...} is must to highlight the cell with green color for the selected block time getting in the response.
                onMouseDown={() => isCurrentlyEditing && this.handleMouseDown(day, time)}  
                onMouseEnter={() => isCurrentlyEditing && this.handleMouseEnter(day, time)}
                onMouseUp={this.handleMouseUp}
              ></div>
            // </Tooltip>
          ))}
              </div>
            ))}
          </div>
          </div>

          <div className="buttons-schedule">
            {!isCurrentlyEditing ? (
              <button 
                onClick={this.toggleEditMode}
                id="rowsPerPageButton"
                disabled={this.props.status === 'inactive' || this.props.manualDeviceInactiveStatus === 'inactive' || cameraLength === 0 
                  || (isVideoAnalyticsMode === false && this.state.isAllCamerasMuted === true)
                } // Disable if device is inactive or no cameras or no VA schedule blocks
                style={{
                  backgroundImage:
                    (this.props.status === 'inactive' || this.props.manualDeviceInactiveStatus === 'inactive' || cameraLength === 0 || (isVideoAnalyticsMode === false && this.state.isAllCamerasMuted === true))
                      ? 'linear-gradient(145deg,rgb(120, 125, 126),rgb(174, 186, 188))'
                      : '',
                  cursor:
                    (this.props.status === 'inactive' || this.props.manualDeviceInactiveStatus === 'inactive' || cameraLength === 0)
                      ? 'not-allowed'
                      : 'pointer',
                }}
                title={
                        (this.props.status === 'inactive' || this.props.manualDeviceInactiveStatus === 'inactive' || cameraLength === 0 || (isVideoAnalyticsMode === false && this.state.isAllCamerasMuted === true))
                          ? 'Cannot edit schedule either this device is offline or no cameras are available or unmute.'
                          : 'Click to edit schedule.'
                      }
              >
                Edit
              </button>
                ) : (
              <>
                <button
                onClick={
                  this.state.isVideoAnalyticsMode
                    ? this.sendVADeviceSchedule // 🔁 Replaces placeholder
                    : this.sendDeviceSchedule
                }
                className="save-button-schedule"
              >
                Save
              </button>

              <button
                onClick={
                  this.state.isVideoAnalyticsMode
                    ? this.clearVideoAnalyticsSchedule // ✅ Fixed method name
                    : this.clearAllSchedules
                }
                className="clear-button-schedule"
              >
                Clear Table
              </button>

                <button onClick={this.cancelEdit} className="cancel-button-schedule">
                  Cancel
                </button>
              </>
            )}
          </div>
        </div>
      </ThemeProvider>
    );
  }
}

export default Scheduler;
